export const Term = () => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-12">
            <div className="about-text">
              <h2>Terms & Conditions</h2>
              <h3>Bible – iTreasure Kids</h3>

              <p>
                By accessing or using Bible – iTreasure Kids, you agree to these
                Terms & Conditions. If you do not agree, please do not use the
                platform.
              </p>

              {/* 1. Purpose */}
              <h3>1. Purpose</h3>
              <ul>
                <li>
                  Bible – iTreasure Kids is an educational platform designed to
                  help users learn the Holy Bible through reading, listening,
                  and interactive games.
                </li>
              </ul>

              {/* 2. Eligibility */}
              <h3>2. Eligibility</h3>
              <ul>
                <li>Users of all ages may use the platform.</li>
                <li>
                  Children should use the platform under parental or guardian
                  supervision.
                </li>
                <li>Content is provided based on selected age groups.</li>
              </ul>

              {/* 3. Accounts & Profiles */}
              <h3>3. Accounts & Profiles</h3>
              <ul>
                <li>Users are responsible for the information they provide.</li>
                <li>Offensive names, images, or content are not allowed.</li>
                <li>
                  We reserve the right to remove inappropriate profiles or
                  content.
                </li>
              </ul>

              {/* 4. Games, Coins & Rewards */}
              <h3>4. Games, Coins & Rewards</h3>
              <ul>
                <li>Coins and rewards have no real-world monetary value.</li>
                <li>Game rules and rewards may change at any time.</li>
                <li>Progress is based on gameplay performance.</li>
              </ul>

              {/* 5. Content Ownership */}
              <h3>5. Content Ownership</h3>
              <ul>
                <li>
                  All content, including Bible games, design, and features,
                  belongs to Bible – iTreasure Kids or is used with permission.
                </li>
                <li>
                  Content may not be copied or redistributed without approval.
                </li>
              </ul>

              {/* 6. Acceptable Use */}
              <h3>6. Acceptable Use</h3>
              <ul>
                <li>Upload harmful or inappropriate content</li>
                <li>Misuse or disrupt the platform</li>
                <li>Attempt unauthorized access to the system</li>
              </ul>

              {/* 7. Language & Voice Features */}
              <h3>7. Language & Voice Features</h3>
              <ul>
                <li>
                  Text-to-speech and translation features are provided as-is.
                </li>
                <li>
                  Accuracy may vary depending on language and system
                  limitations.
                </li>
              </ul>

              {/* 8. Termination */}
              <h3>8. Termination</h3>
              <ul>
                <li>
                  We reserve the right to suspend or terminate access if these
                  terms are violated.
                </li>
              </ul>

              {/* 9. Limitation of Liability */}
              <h3>9. Limitation of Liability</h3>
              <ul>
                <li>Bible – iTreasure Kids is provided “as is”.</li>
                <li>
                  We are not responsible for service interruptions, data loss,
                  or misuse by users.
                </li>
              </ul>

              {/* 10. Changes to Terms */}
              <h3>10. Changes to Terms</h3>
              <ul>
                <li>
                  We may update these Terms & Conditions at any time. Continued
                  use means acceptance of the updated terms.
                </li>
              </ul>

              {/* 11. Contact Information */}
              <h3>11. Contact Information</h3>
              <ul>
                <li>
                  For questions regarding these Terms & Conditions, please
                  contact us at:
                </li>
                <li>📧 Email: info@itreasure.app</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
